import Moment from 'moment';

/**
 * Activity timestamps arrive as epoch milliseconds. `Moment(undefined)` is
 * *now*, so anything unusable is rejected explicitly rather than being allowed
 * to render as the current time.
 */
const toMoment = (value: unknown) => {
  if (value === null || value === undefined || value === '') {
    return null;
  }
  const parsed = Moment(value as Moment.MomentInput);
  return parsed.isValid() ? parsed : null;
};

/** Whether an event happened on the reader's current calendar day. */
export function isFromToday(value: unknown, now: number = Date.now()): boolean {
  const moment = toMoment(value);
  return moment ? moment.isSame(Moment(now), 'day') : false;
}

/**
 * Formats an activity timestamp the way the panel reads it: recent events by
 * their relation to today, older ones by date, and the year only once it stops
 * being obvious.
 */
export function formatActivityTimestamp(
  value: unknown,
  now: number = Date.now()
): string {
  const moment = toMoment(value);
  if (!moment) {
    return '';
  }

  const today = Moment(now);
  const time = moment.format('h:mm A');

  if (moment.isSame(today, 'day')) {
    return `Today, ${time}`;
  }
  if (moment.isSame(today.clone().subtract(1, 'day'), 'day')) {
    return `Yesterday, ${time}`;
  }
  if (moment.isSame(today, 'year')) {
    return `${moment.format('MMM D')}, ${time}`;
  }
  return `${moment.format('MMM D, YYYY')}, ${time}`;
}
